<template>
  <div>
      <div class="bodyWrap">
          <header>
              <div class="headTop">
                  <div class="topBox">
                       <div class="headLeft fl">
                        <span>时间：2021年3月31日</span>
                        <span>星期三</span>
                      </div>
                      <div class="headRig fr">
                  <router-link  to="/login" tag="span">登录</router-link>
                           <router-link to="/register" tag="span">注册</router-link>
                      </div>
                  </div>
              </div>
              <div class="headBottom">
                 <div class="bottomBox">
                    <div class="botLeft fl">
                    <img src="../../assets/img/show/logo.png" alt="">
                  </div>
                  <div class="botdRig fr">
                    <ul class="fl headUl">
                      <li>资源管理</li>
                      <li>统计分析</li>
                      <li>返回信息网</li>
                    </ul>
                    <div class="fr headSearch">
                          <el-input v-model="input" placeholder="发现数据从这里开始"></el-input>
                          <span>
                              <img src="../../assets/img/show/search.png" alt="">
                          </span>
                    </div>
                  </div>
                 </div>
              </div>
          </header>
          <div class="banner"> 
                <img src="../../assets/img/show/banner.png" alt="">
          </div>
          <div class="main">
            <div class="title">
                 <p>当前位置：首页 > 新闻资讯</p>
            </div>
            <div class="tabZujian">
            <el-tabs v-model="activeName">
                <el-tab-pane label="新闻资讯" name="first" :key="'first'">
                    <ul class="newsList">
                      <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>品资所开展“我健康、我快乐”健步走活动</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>植物世界尽芳菲 快乐科普进校园</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>我愿做一名普通的热作科技传播者</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>“三区人才”小分队到东方开展技术服务</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>我所专家与泰国科技发展署开展学术交流， 执行“一带一路”项目任务</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                    </ul>
                    <div class="pageNew">
                       <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="100">
                      </el-pagination>
                      <div class="pageIndex">
                          <span>跳至</span>
                          <input type="text" placeholder="1">
                          <span>页</span>
                      </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="通知公告" name="second" :key="'second'">
                    <ul class="newsList">
                        <li>
                         <p>植物世界尽芳菲 快乐科普进校园</p>
                         <span>2020-08-07</span>
                      </li>
                      <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>品资所开展“我健康、我快乐”健步走活动</p>
                         <span>2020-08-07</span>
                      </li>
                       
                         <li>
                         <p>我愿做一名普通的热作科技传播者</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>“三区人才”小分队到东方开展技术服务</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>我所专家与泰国科技发展署开展学术交流， 执行“一带一路”项目任务</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                    </ul>
                    <div class="pageNew">
                       <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="100">
                      </el-pagination>
                      <div class="pageIndex">
                          <span>跳至</span>
                          <input type="text" placeholder="1">
                          <span>页</span>
                      </div>
                    </div>
                </el-tab-pane>
                 <el-tab-pane label="媒体报道" name="second2" :key="'second2'">
                    <ul class="newsList">
                     <li>
                         <p>品资所开展“我健康、我快乐”健步走活动</p>
                         <span>2020-08-07</span>
                      </li>
                      <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                   
                         <li>
                         <p>植物世界尽芳菲 快乐科普进校园</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>我愿做一名普通的热作科技传播者</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>“三区人才”小分队到东方开展技术服务</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>我所专家与泰国科技发展署开展学术交流， 执行“一带一路”项目任务</p>
                         <span>2020-08-07</span>
                      </li>
                         <li>
                         <p>小小植物体验官开启植物叶片的奇妙大门</p>
                         <span>2020-08-07</span>
                      </li>
                    </ul>
                    <div class="pageNew">
                       <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="100">
                      </el-pagination>
                      <div class="pageIndex">
                          <span>跳至</span>
                          <input type="text" placeholder="1">
                          <span>页</span>
                      </div>
                    </div>
                </el-tab-pane>
              </el-tabs>
          </div>
          </div>
           
    <footer>
         <p>主持单位:中国热带农业科学院热带作物品种资源研究所 | 版权所有©热带作物种质资源信息网</p>
    </footer>
      </div>
  </div>
</template>
<script>
export default {
  name: "newsList",
  data() {
    return {
     input: '',
     //默认第一个选项卡
            activeName: "first",
    };
  },
  methods: {
  

  },
};
</script>
<style scoped>
@import "../../assets/scss/show.css";
  .bodyWrap{
    width:100%;
    margin:0 auto;
    background: #eeeeee;
  }
  .main{
     width: 1200px;
     margin: 0 auto;
  }
  .pageNew{
    margin:38px auto 0 auto;
    text-align: center;
  }
  .pageIndex{
    display: inline-block;
    padding: 2px 0;vertical-align: bottom;
  }
  .pageIndex span{
     font-size: 13px;
     color: #606266;
  }
  .pageIndex input{
    width: 40px;
    border: 1px solid #dddee1;
    text-align: center;
    font-size: 13px;
    height: 26px;
    line-height: 26px;
    border-radius:3px;
  }
  .title{
    padding:27px 0 20px 0;
  }
  .title p{
    font-size: 12px;
    color: #666666;
  }
  .botdRig {
    margin-right: 45px;
  }
  .banner img{
    height: 150px;
    display: block;
    width: 100%;
  }
  footer{
    height: 84px;
    line-height: 84px;
    background: #4a4e53;
    margin-top: 66px;
    text-align: center;
  }
  footer p{
    font-size: 14px;
    color: #fff;
  }
  .newsList{
    margin-top: 28px;
  }
  .newsList li:nth-child(odd){
    background: #d6e3dd;
  }
  .newsList li{
    height: 70px;
    line-height: 70px;
    padding: 0 50px 0 40px;
  }
  .newsList li p{
    display: inline-block;
    color: #333333;
    font-size: 16px;
  }
   .newsList li span{
    display: inline-block;
    color: #333333;
    font-size: 16px;
    float: right;
  }
.el-tabs__item{
    font-size: 20px;
    color:#02874a;
  }
  .bottomBox{
    width: 1200px;
     margin: 0 auto;
  }
  .headBottom{
    background:#fff;
    height: 100px;
     
  }
  .headSearch{
    height: 40px;
    margin-top: 30px;
    position: relative;
  }
  .headSearch span{
        background: #02874a;
    position: absolute;
    right: -45px;
    top: 0;
    height: 38px;
    width: 51px;
    border: 1px solid #02874a;
    border-top-right-radius: 5px;
    border-left: 0;
    border-bottom-right-radius: 5px;
  }
  .headSearch span img{
    margin: 0 auto;
    text-align: center;
    display: block;
    margin-top: 7px;
    height: 24px;
  }
  .botLeft img{
   width: 489px;
   height: 42px;
   display: block;
   margin-top:29px;
  }
  .headUl li{
    font-size: 16px;
    color: #333333;
    display: inline-block;
    float: left;
    margin-right: 40px;
    line-height: 100px;
  }
  .topBox{
      width: 1200px;
       margin: 0 auto;
  }
  .headTop{
    background:#f1f1f1;
    height: 30px;
    line-height: 28px;
  }
  .el-input__inner{
    border: 1px solid #02874a !important;
    font-size: 14px;
  }
  .headLeft span{
    font-size: 12px;
    color: #666666;
    display: inline-block;
    margin-right: 30px;
  }
  .headRig span{
    font-size: 12px;
    color: #666666;
    margin-left: 30px;
     display: inline-block;
  }
</style>
